'use client';

import { Target, Building2, Users, Briefcase, Globe } from 'lucide-react';
import type { ProductUseCase } from '@/lib/data/software';

interface UseCaseCardsProps {
  useCases: ProductUseCase[];
  className?: string;
}

// Icons to cycle through for visual variety
const icons = [Target, Building2, Users, Briefcase, Globe];

export default function UseCaseCards({ useCases, className = '' }: UseCaseCardsProps) {
  if (!useCases || useCases.length === 0) {
    return null;
  }

  return (
    <section className={`py-8 sm:py-10 bg-gray-50 dark:bg-gray-800 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mb-5 sm:mb-6 text-center">
          Ideal For
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 sm:gap-4">
          {useCases.map((useCase, index) => {
            const Icon = icons[index % icons.length];
            return (
              <div
                key={useCase.id}
                className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4 sm:p-5 hover:border-blue-300 transition-colors"
              >
                <div className="flex items-center gap-2.5 mb-2.5">
                  <div className="w-8 h-8 sm:w-9 sm:h-9 bg-blue-50 dark:bg-blue-950/40 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 dark:text-blue-400" />
                  </div>
                  <h3 className="font-semibold text-gray-900 dark:text-gray-100 text-sm sm:text-base">
                    {useCase.title}
                  </h3>
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                  {useCase.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
